import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function LogoutCallback() {
  const history = useHistory();

  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    history.push("/login");
  }, []);

  return <p>Logging out...</p>;
}
